import React, { useEffect } from "react";
import NoRecordFound from "components/NoRecordFound/NoRecordFound";
import {
  Table
} from "reactstrap";
import moment from "moment";
import { getSortCls, reportloader } from "services/util";
import { btnCss, iconCss, ReportStatus } from '../../appConfig';
import FullPageLoader from "components/FullPageLoader/fullpageloader";


const sortIS = {
  sortPaymentFrom: 0,
  sortSubscriberName: 0,
  sortPaymentType: 0,
  sortAmount: 0,
  sortFeesAmount: 0,
  sortReferenceId: 0,
  sortMerchantName: 0,
  sortDate: 0,
  sortStatus: 0,
};

const reportloaderContainer = {
  position: 'absolute',
  top: '280px',
  left: 0,
  width: '100%',
  heigth: '100%',
  backgroundColor: '#F8F8F8AD',
  // display: 'none'
};

const STATUS = ReportStatus;


const BankReportTable = (props) => {

  const [filteredList, setFilteredList] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [sort, setSort] = React.useState(sortIS);

  useEffect(()=> {
    setFilteredList(props.datalist)
  }, [props.datalist]);

  useEffect(()=> {
    setCurrentPage(props.currentPage);
  }, [props.currentPage]);

  useEffect(()=> {
    setPageSize(props.pageSize);
  }, [props.pageSize]);

  useEffect(()=> {
    props.setParentSort(sort);
  }, [sort]);

  const getAmt = (amt) => {
    return amt.toLocaleString();
  }

  const sortHandle = (fieldValue, fieldName) => {
    let newValue = 0;
    if (fieldValue == "0") {
      newValue = '1';
    } else if (fieldValue == "1") {
      newValue = '2';
    } else if (fieldValue == "2") {
      newValue = '1';
    }
    setSort({ ...sortIS, [fieldName]: newValue });
  }

  const statusFormat = (val) => {
    let ob = STATUS.find((s) => s.key === val);
    return ob && ob.value ? ob.value : val 
  };

  const getPaymentType = (type) => {
    if (type == 'topup') {
      return 'Top Up';
    } else if (type == 'Merchant') {
      return 'Merchant Payment';
    } else {
      return type;
    }

  }

  return (
    <>
      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col"
              onClick={() => sortHandle(sort.sortPaymentFrom, 'sortPaymentFrom')}>
              Bank Name
              <button style={btnCss} >
                <i className={getSortCls(sort.sortPaymentFrom)}
                  onClick={() => sortHandle(sort.sortPaymentFrom, 'sortPaymentFrom')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortSubscriberName, 'sortSubscriberName')}>
              Subscriber Name
              <button style={btnCss} >
                <i className={getSortCls(sort.sortSubscriberName)}
                  onClick={() => sortHandle(sort.sortSubscriberName, 'sortSubscriberName')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortDate, 'sortDate')}>
              Date
              <button style={btnCss} >
                <i className={getSortCls(sort.sortDate)}
                  onClick={() => sortHandle(sort.sortDate, 'sortDate')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortPaymentType, 'sortPaymentType')}>
              Payment Type
              <button style={btnCss} >
                <i className={getSortCls(sort.sortPaymentType)}
                  onClick={() => sortHandle(sort.sortPaymentType, 'sortPaymentType')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortMerchantName, 'sortMerchantName')}>
              Merchant Name
              <button style={btnCss} >
                <i className={getSortCls(sort.sortMerchantName)}
                  onClick={() => sortHandle(sort.sortMerchantName, 'sortMerchantName')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortAmount, 'sortAmount')}>
              Amount
              <button style={btnCss} >
                <i className={getSortCls(sort.sortAmount)}
                  onClick={() => sortHandle(sort.sortAmount, 'sortAmount')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortFeesAmount, 'sortFeesAmount')}>
              Transaction Fees
              <button style={btnCss} >
                <i className={getSortCls(sort.sortFeesAmount)}
                  onClick={() => sortHandle(sort.sortFeesAmount, 'sortFeesAmount')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortReferenceId, 'sortReferenceId')}>
              Transaction Ref
              <button style={btnCss} >
                <i className={getSortCls(sort.sortReferenceId)}
                  onClick={() => sortHandle(sort.sortReferenceId, 'sortReferenceId')}
                />
              </button>
            </th>
            <th scope="col" 
              onClick={() => sortHandle(sort.sortStatus, 'sortStatus')}>
              Status
              <button style={btnCss} >
                <i className={getSortCls(sort.sortStatus)}
                  onClick={() => sortHandle(sort.sortStatus, 'sortStatus')}
                />
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
        {filteredList.length > 0 && filteredList.map((mmo, i)  => {
          return (
            <tr>
              <td>{mmo.paymentFrom}</td>
              <td>{mmo.subscriberName}</td>
              <td>{moment(mmo.updatedAt).format('lll')}</td>
              <td>{getPaymentType(mmo.paymentType)}</td>
              <td>{mmo.merchantName ? mmo.merchantName : '--'}</td>
              <td>{getAmt(mmo.amount)}</td>
              <td>{getAmt(mmo.feesAmount)}</td>
              <td>{mmo.referenceId}</td>
              <td>{statusFormat(mmo.status)}</td>
            </tr>

          )
        }
        )}
        </tbody>
        {props.loading && 
          <FullPageLoader label={"Fetching..."} 
            loaderContainer={reportloaderContainer}
            loader={reportloader}
          />
        }
        {!props.loading && !filteredList.length && 
          <NoRecordFound 
            loaderContainer={reportloaderContainer}
            loader={reportloader}
          />
        }
      </Table>       
    </>
  )
}

export default BankReportTable;